import InsightCard from './InsightCard';
import illustrationSvg from '../../components/assets/illustration-icon.svg';
import mapSvg from '../../components/assets/map-icon.svg';
import treasureMapSvg from '../../components/assets/treasure-map-icon.svg';
import settingsSvg from '../../components/assets/settings-icon.svg';
import calendarSvg from '../../components/assets/calendar-icon.svg';

import { Box, Grid } from '@mui/material';
import { spacings } from '../../theme';

const InsightCardList = () => {
  const cardContent = [
    // {
    //   title: 'Insights from the 2024 Index',
    //   content:
    //     'Our report includes the previous top 75, case studies and best practice.',
    //   imgSrc: illustrationSvg,
    //   btnLabel: 'Download',
    //   onAction: () =>
    //     window.open(
    //       'https://tsmf.sharepoint.com/sites/SMF-External/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FSMF%2DExternal%2FShared%20Documents%2FThe%20Social%20Mobility%20Employer%20Index%2F2024%2FKey%20Findings%20Report%202024%2Epdf&parent=%2Fsites%2FSMF%2DExternal%2FShared%20Documents%2FThe%20Social%20Mobility%20Employer%20Index%2F2024&p=true&ga=1',
    //       '_blank'
    //     )
    // },
    {
      title: 'A guide to measuring your organisation’s class pay gap',
      content:
        'Our practical how to guide includes the steps to take and examples of those who already have.',
      imgSrc: treasureMapSvg,
      btnLabel: 'View the guide',
      onAction: () =>
        window.open(
          'https://tsmf.sharepoint.com/sites/SMF-External/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FSMF%2DExternal%2FShared%20Documents%2FAdvocacy%20%26%20Campaigns%2FLevelling%20The%20Playing%20Field%20%2D%20A%20practical%20guide%20for%20calculating%20your%20socioeconomic%20pay%20gap%2Epdf&parent=%2Fsites%2FSMF%2DExternal%2FShared%20Documents%2FAdvocacy%20%26%20Campaigns&p=true&ga=1',
          '_blank'
        )
    },
    {
      title: 'The Social Mobility Commission’s cross-industry toolkit',
      content:
        'Guidance and practical advice for employers including advice on data collection and benchmarking.',
      imgSrc: settingsSvg,
      btnLabel: 'View the toolkit',
      onAction: () =>
        window.open(
          'https://socialmobility.independent-commission.uk/toolkit/cross-industry-toolkit',
          '_blank'
        )
    },
    {
      title: 'Guidance for the Index Survey',
      content:
        'Resources for your submission and details of the questions we have updated or amended since last year',
      imgSrc: calendarSvg,
      btnLabel: 'View notes & changes',
      onAction: () =>
        window.open(
          'https://tsmf.sharepoint.com/:f:/s/SMF-External/IgDLi9TlKTkSQb2KfyFKhNEgAfRjlA0JgpMQQ--u81SMJHI?e=Ranm2l',
          '_blank'
        )
    },
    {
      title: 'Schools targeting map',
      content:
        'An interactive map to enable you to identify and target schools in the UK who most need your support the most.',
      imgSrc: mapSvg,
      btnLabel: 'View map',
      onAction: () =>
        window.open(
          'https://www.socialmobility.org.uk/find-schools-for-impact',
          '_blank'
        )
    },
    {
      title: 'Evaluation resources',
      content:
        'Additional advice and resources for measuring and evaluating your outreach work.',
      imgSrc: illustrationSvg,
      btnLabel: 'View resources',
      onAction: () =>
        window.open('https://tsmf.sharepoint.com/:b:/s/SMF-External/IQCgUnyZQPu3TpTf1gL6TndHARXzHXlyNozXidFRmngQHBg?e=scPuft', '_blank')
    }
  ];
  return (
    <Grid container spacing={spacings[4]}>
      {cardContent.map((e, i) => {
        return (
          <Grid item xs={12} sm={12} md={4} key={`insight-card-${i}`}>
            <Box
              marginTop={{ xs: 0, md: 2 }}
              onClick={e.onAction}
              sx={{ cursor: 'pointer' }}
            >
              <InsightCard
                title={e.title}
                content={e.content}
                btnLabel={e.btnLabel}
                imgSrc={e.imgSrc}
                onAction={e.onAction}
              />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default InsightCardList;
